<template>
  <v-menu
    offset-y
    origin="center center"
    :nudge-bottom="10"
    transition="scale-transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{on}">
      <v-btn
        class="mr-4"
        icon
        large
        v-on="on"
        @click="refreshNotifications"
        data-cy="showNotificationsBtn"
      >
        <v-badge
          :content="checkNotReadNotificationsCount"
          :value="checkNotReadNotificationsCount"
          color="red"
          overlap
        >
          <v-icon x-large class="blue--text">
            notifications
          </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list
      class="app-notifications pa-0"
      :width="1000"
      max-width="100%"
      :max-height="(showNotificationCount + 1) * 60"
      data-cy="appNotifications"
    >
      <v-list-item-group
        multiple
      >
        <v-list-item
          v-for="item in notifications"
          :key="item.id"
          :class="{'v-list-item--custom-active': !item.isSeen}"
          @click="notificationAction(item)"
          data-cy="appNotification"
          :data-cy-notification-id="item.id"
        >
          <v-list-item-icon>
            <v-icon>
              {{notificationTypeIcon[item.type]}}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{item.message}}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              icon
              :title="item.isSeen ? $t('notification.actions.markAsUnread') : $t('notification.actions.markAsRead')"
              @click.stop="toggleSeenStatus(item.id)"
              data-cy="notificationToggleSeen"
            >
              <v-icon small>
                {{item.isSeen ? 'radio_button_unchecked' : 'fiber_manual_record'}}
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
      <v-list-item
        v-if="hasMoreToLoad"
      >
        <v-btn
          small
          class="mx-auto"
          @click="loadMoreNotifications"
          data-cy="showMoreNotifications"
        >
          <v-icon class="mr-2" small>
            add
          </v-icon>
          {{$t('notification.actions.more')}}
        </v-btn>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import * as actions from '@/store/actions.type';
  import {
    NOTIFICATION_ERROR,
  } from '@/common/event.types';
  import {NOTIFICATION_TYPE_ICON} from '@/constants/notification';
  import * as routeConstants from '@/router/constants';

  export default {
    name: 'AppNotifications',
    data: () => ({
      notificationTypeIcon: NOTIFICATION_TYPE_ICON,
      routeConstants: routeConstants,
      showNotificationCount: 5,
      turn: 1,
    }),
    computed: {
      ...mapGetters([
        'notifications',
        'totalNotificationsCount',
        'notReadNotificationsCount',
        'checkNotReadNotificationsCount',
        'hasMoreToLoad',
      ]),
      params() {
        return {
          take: this.showNotificationCount,
          skip: 0,
        };
      },
      loadMore() {
        return {
          take: this.showNotificationCount,
          skip: 0,
        };
      },
      lastSeenNotification() {
        const lastNotification = this.turn * this.params.take;

        if (this.totalNotificationsCount <= lastNotification) {
          return this.totalNotificationsCount;
        } else {
          return lastNotification;
        }
      },
    },
    watch: {
      $route() {
        this.getNotReadNotificationsCountAction();
      },
    },
    mounted() {
      this.getNotReadNotificationsCountAction();
      this.fetchNotificationsAction(this.params);
    },
    destroyed() {
      this.resetNotificationParamsAction();
    },
    methods: {
      ...mapActions({
        fetchNotificationsAction: actions.FETCH_NOTIFICATIONS,
        loadMoreNotificationsAction: actions.LOAD_MORE_NOTIFICATIONS,
        updateReadStatusAction: actions.UPDATE_READ_STATUS,
        resetNotificationParamsAction: actions.RESET_NOTIFICATION_PARAMS,
        getNotReadNotificationsCountAction: actions.GET_NOT_READ_NOTIFICATIONS_COUNT,
      }),
      toggleSeenStatus(notificationId) {
        this.updateReadStatusAction(notificationId).then(() => {
          this.fetchNotificationsAction(this.params);
          this.getNotReadNotificationsCountAction();
        }).catch(({data}) => {
          this.$eventHub.$emit(NOTIFICATION_ERROR, {
            message: data.title,
          });
        });
      },
      notificationAction(item) {
        if (!item.isSeen) {
          this.updateReadStatusAction(item.id).then(() => {
            this.fetchNotificationsAction(this.params);
            this.getNotReadNotificationsCountAction();
          }).catch(({data}) => {
            this.$eventHub.$emit(NOTIFICATION_ERROR, {
              message: data.title,
            });
          });
        }

        this.$router.push({path: routeConstants.MOVES_URL, query: {name: item.moveName}});
      },
      loadMoreNotifications() {
        this.loadMore.skip = this.turn * this.loadMore.take;
        this.loadMoreNotificationsAction(this.loadMore);
        this.turn++;
        this.params.take = this.lastSeenNotification;
      },
      refreshNotifications() {
        this.fetchNotificationsAction(this.params);
        this.getNotReadNotificationsCountAction();
      },
    },
  };
</script>

<style lang="scss">
  .app-notifications {
    overflow: auto;

    .v-list-item--active {
      color: #0f2332;

      &::before {
        background: none;
      }
    }

    .v-list-item--custom-active {
      &,
      &.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: #2196F3 !important;

        &::before {
          background-color: currentColor;
          opacity: 0.12;
        }
      }
    }

    .v-list-item__action,
    .v-list-item__icon {
      .v-btn--icon,
      .v-icon {
        color: currentColor !important;
      }
    }

    .v-list-item .v-list-item__title {
      white-space: normal;
      line-height: 1.4;
    }
  }
</style>
